export default "__VITE_ASSET__DuEQiQEz__"